import { render, staticRenderFns } from "./vehicle-manage.vue?vue&type=template&id=3007d454&scoped=true"
import script from "./vehicle-manage.vue?vue&type=script&lang=js"
export * from "./vehicle-manage.vue?vue&type=script&lang=js"
import style0 from "./vehicle-manage.vue?vue&type=style&index=0&id=3007d454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007d454",
  null
  
)

export default component.exports